import { render } from "./ViewerBottomBar.vue?vue&type=template&id=6dc71873&scoped=true"
import script from "./ViewerBottomBar.vue?vue&type=script&lang=js"
export * from "./ViewerBottomBar.vue?vue&type=script&lang=js"

import "./ViewerBottomBar.vue?vue&type=style&index=0&id=6dc71873&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc71873"]])

export default __exports__